export default __webpack_public_path__ + "5c38a9672840d6fbe7e473e8aacedc9f.svg";